/**
 * Initialize menu button.
 *
 * @param header
 */
export const initMenuButton = header => {
    if (!header) return;

    const menuButton = header.querySelector('.menu-button');
    if (!menuButton) return;

    const addWhiteRemoveBrownClass = () => {
        menuButton.classList.add('white');
        menuButton.classList.remove('brown');
    };

    if (header.classList.contains('logo-dark')) {
        header.addEventListener('mouseover', () => addWhiteRemoveBrownClass());

        const addBrownRemoveWhiteClass = () => {
            menuButton.classList.remove('white');
            menuButton.classList.add('brown');
        };

        header.addEventListener('mouseleave', () => {
            if (header.querySelector('.flyout')?.classList?.contains('flyout-open')) {
                addBrownRemoveWhiteClass();
            } else {
                addBrownRemoveWhiteClass();
            }
        });
    } else {
        addWhiteRemoveBrownClass();
    }
};
